export function NoData({
	msg,
	className = `flex justify-center w-full`,
}: {
	msg: string;
	h?: number;
	className?: string;
}) {
	return <div className={className + " text-center py-12 text-gray-600"}>{msg}</div>;
}
